<template>
  <el-row>
    <el-col>
      <basic-container>
        <el-card class="box-card">
          <div slot="header"
               class="clearfix">
            <span>[{{dictValue}}] 资源配置</span>
          </div>
          <div class="clearfix">
            <avue-crud :option="optionChild"
                       :table-loading="loadingChild"
                       :data="dataChild"
                       ref="crudChild"
                       v-model="formChild"
                       :permission="permissionList"
                       :before-open="beforeOpenChild"
                       @row-del="rowDelChild"
                       @row-update="rowUpdateChild"
                       @row-save="rowSaveChild"
                       @search-change="searchChangeChild"
                       @search-reset="searchResetChild"
                       @selection-change="selectionChangeChild"
                       @current-change="currentChangeChild"
                       @size-change="sizeChangeChild"
                       @refresh-change="refreshChangeChild"
                       @on-load="onLoadChild"
                       @sortable-change="sortableChildChange"
                       :upload-before="uploadBefore"
                       :upload-error="uploadError"
                       >
              <template slot="menuLeft">
                <el-button type="danger"
                           size="small"
                           icon="el-icon-delete"
                          v-auth="'enterpriseTemplate_del'"
                           plain
                           @click="handleDeleteChild">删 除
                </el-button>
                <el-tooltip content="拖动数据可以进行排序!" placement="right">
                  <!-- <el-button type="success"
                           size="small"
                           icon="el-icon-check"
                           @click="handleSaveSort">保存排序
                </el-button> -->
                </el-tooltip>
              </template>
              <template slot="icon" slot-scope="{row}">
                  <el-image v-if="row.icon" :src="row.icon" style="width:100px;height:50px;cursor:pointer;" @click="showImge(row.image)"></el-image>
              </template>
              <template slot="image" slot-scope="{row}">
                  <el-image :src="row.image" style="width:100px;height:50px;cursor:pointer;" @click="showImge(row.image)"></el-image>
              </template>
              <template slot="appidFilterList" slot-scope="{row}">
                <template v-if="row.appidFilterNames">
                    <template v-if="row.appidFilterNames.split(';').length <5 ">
                      <el-tag v-for="(item, index) in row.appidFilterNames.split(';') " :key="index">
                              {{ item}}
                      </el-tag>
                    </template>
                    <template v-else>
                      <el-tag>{{row.appidFilterNames.split(';')[0]}}</el-tag>
                      <el-popover
                        placement="right"
                        width="400"
                        trigger="click">
                        <div>
                          <el-tag size="mini" v-for="(item, index) in row.appidFilterNames.split(';')" :key="index">{{item}}</el-tag>
                        </div>
                        <el-tag size="mini" slot="reference" class="el-icon-right">展开更多</el-tag>
                      </el-popover>
                  </template>
                </template>
              </template>
               <template slot-scope="scope"
                    slot="eventType">
                {{scope.dic.filter(item => [scope.row.eventType+''].includes(item.dictKey))[0].dictValue }}
              </template>
              <template slot-scope="scope"
                        slot="appidFilterListForm">
                <el-input type="textarea"
                          @focus="handleClick()"
                          v-model="formChild.appidFilterNames"> </el-input>
              </template>
              <template slot-scope="{row}"
                        slot="isSealed">
                <el-tag>{{row.isSealed===0?'否':'是'}}</el-tag>
              </template>
            </avue-crud>
          </div>
        </el-card>
        <channel-popups :app-id="formChild.appidFilterList"
                        :visible.sync="activityForm.showPopups"
                        @comfirm="handleConfirm"></channel-popups>
      </basic-container>
    </el-col>
  </el-row>
</template>

<script>
import {
  getResourceChildList,
  appResourceItemRemove,
  appResourceItemSaveSort,
  appResourceItemSubmit,
  getPcCode
} from "@/api/desk/notice";
import { optionChild } from "./const/enterpriseTemplate";
import { mapGetters, mapActions } from "vuex";
import AvueUeditor from 'avue-plugin-ueditor';
import ChannelPopups from '@/components/channel-popups';

export default {
  data () {
    return {
      dictValue: '暂无',
      activityForm: {
        appId: '',
        channel: '',
        showPopups: false

      },
      showImage:'',
      sortIds: '',
      parentId: -1,
      formChild: {
        appidFilterType: 0
      },
      selectionList: [],
      query: {},
      loading: true,
      loadingChild: true,
      pageChild: {
        pageSize: 10,
        pageSizes: [10, 30, 50, 100, 200],
        currentPage: 1,
        total: 0
      },
      dataChild: [],
      optionChild: optionChild,
    };
  },
  watch: {
    'formChild.appidFilterType': {
      handler (v) {
        console.log('[watch.handlerChangeValue]', v)
        let appidFilterList = this.findObject(this.optionChild.column, 'appidFilterList')
        let appidFilterType = this.findObject(this.optionChild.column, 'appidFilterType')
        if (v) {
          appidFilterType.row = false
          appidFilterList.display = true
        } else {
          appidFilterType.row = true
          appidFilterList.display = false
        }
      }
    },
  },
  components: {
    ChannelPopups,
    AvueUeditor
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList () {
      return {
        addBtn: this.vaildData(this.permission.enterpriseTemplate_add, false),
        delBtn: this.vaildData(this.permission.enterpriseTemplate_del, false),
        editBtn: this.vaildData(this.permission.enterpriseTemplate_edit, false),
        viewBtn: false,
      };
    },
    ids () {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  },
  mounted () {
    this.getPcList()
  },
  methods: {
    ...mapActions('runActivityManage', ['clearDicts']),
    uploadBefore(file, done, loading,column) {
      console.log(column,file)
      // var newFile = new File([file], '1234', { type: file.type });
      if(file.size >  1024*1000){
          this.$message.success('上传图片过大')
          loading();
      }else{
            done();
      }
    },
    uploadError(error) {
      this.$message.success(error);
    },
    showImge(url){
      this.$alert("<img src='"+url+"' style='width:100%'>" ,'图片展示', {
          dangerouslyUseHTMLString: true,
          showConfirmButton:false,
          customClass:'showImage'
        });
    },
    // 选择渠道
    handleConfirm (data) {
      const { isAll, appId, channel } = data;
      this.formChild.appidFilterList = appId
      this.formChild.appidFilterNames = channel
      if (isAll) {
        this.channel = 1;
        this.activityForm.appId = '';
        this.activityForm.channel = '';
      }
    },
    handleClick () {
      this.activityForm.showPopups = true
    },
    getPcList () {
      getPcCode('dongle-screensaver').then(res => {
        console.log('res', res.data.code)
        if (res.data.code === 200) {
          const selecyItem = {
            id: res.data.data.id,
            name: '企业会议盒子屏保模板'
          }
          this.parentId = selecyItem.id;
          this.dictValue = selecyItem.name;

          // this.$refs.crudChild.value.code = row.code;
          this.$refs.crudChild.value.parentId = selecyItem.id;
          this.$refs.crudChild.option.column.filter(item => {
            if (item.prop === "code") {
              item.value = '';
            }

            if (item.prop === "groupId") {
              item.value = selecyItem.id;
            }
          });
          console.log(this.pageChild)
          this.onLoadChild(this.pageChild);
        }
      })
    },
    selectionClear () {
      this.selectionList = [];
      this.$refs.crudChild.toggleSelection();
    },
    handleSaveSort () {
      if (this.sortIds.length === 0) {
        this.$message.warning("排序未发生变化！");
        return;
      }
      this.$confirm("确定保存现在排序?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {

        return appResourceItemSaveSort(this.sortIds.toString());
      }).then(() => {
        this.$message({
          type: "success",
          message: "操作成功!"
        });
      });
    },
    beforeOpen (done, type) {
      console.log(type, '打开类型暂时不处理')
      // if (["add"].includes(type)) {
      //   this.formChild.appidFilterType = 0
      // }
      done();
    },
    rowSaveChild (row, done, loading) {
      if(row.modAns.length === 0) {
        row.modAns = ''
      }
      if(row.userTags.length === 0) {
        row.userTags = ''
      }
      if(row.userTypes.length === 0) {
        row.userTypes = ''
      }
      appResourceItemSubmit(row).then(() => {
        this.onLoadChild(this.pageChild);
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        done();
      }, error => {
        window.console.log(error);
        loading();
      });
    },
    rowUpdateChild (row, index, done, loading) {

      //  row.appidFilterList = this.activityForm.appId
      // console.log(row)
      appResourceItemSubmit(row).then(() => {
        this.onLoadChild(this.pageChild);
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        done();
      }, error => {
        window.console.log(error);
        loading();
      });
    },
    rowDelChild (row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return appResourceItemRemove(row.id);
        })
        .then(() => {
          this.onLoadChild(this.pageChild);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        });
    },
    searchResetChild () {
      this.query = {};
      this.onLoadChild(this.pageChild);
    },
    searchChangeChild (params, done) {
      this.query = params;
      this.pageChild.currentPage = 1;
      this.onLoadChild(this.pageChild, params);
      done();
    },
    selectionChangeChild (list) {
      this.selectionList = list;
    },
    selectionClearChild () {
      this.selectionList = [];
      this.$refs.crudChild.toggleSelection();
    },
    handleDeleteChild () {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return appResourceItemRemove(this.ids);
        })
        .then(() => {
          this.onLoadChild(this.pageChild);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.$refs.crudChild.toggleSelection();
        });
    },
    beforeOpenChild (done, type) {
      if (["add"].includes(type)) {

        this.activityForm.channel = ''
        this.activityForm.appId = ''

        setTimeout(() => {
          this.formChild.appidFilterType = 0
          this.formChild.status = 1
        }, 0)
        console.log('[beforeOpenChild]', type, this.formChild)
      } else {
        this.formChild.eventType = this.formChild.eventType+''
        // console.log('[beforeOpenChild]', type, this.formChild.eventType)
        // this.activityForm.appId = this.formChild.appidFilterList
        // this.activityForm.channel = this.formChild.appidFilterNames
      }
      done();
    },
    currentChangeChild (currentPage) {
      this.pageChild.currentPage = currentPage;
    },
    sizeChangeChild (pageSize) {
      this.pageChild.pageSize = pageSize;
    },
    refreshChangeChild () {
      this.onLoadChild(this.pageChild, this.query);
    },
    onLoadChild (page, params = {}) {
      this.loadingChild = true;
      getResourceChildList(
        page.currentPage,
        page.pageSize,
        this.parentId,
        Object.assign(params, this.query)
      ).then(res => {
        const data = res.data.data;
        this.dataChild = data;
        this.loadingChild = false;
        this.selectionClear();
      })
    },
    sortableChildChange (oldindex, newindex, row, list) {
      this.data = []
      this.$nextTick(() => {
        this.data = list;
      })
      this.sortIds = list.map((item) => item.id)
    }
  }
};
</script>
<style>
@media only screen and (min-width: 992px){
.el-col-md-6 {
    width: 30%;
}
}

</style>